const path = require('path')

module.exports = function (state) {
    return {
        path: path.resolve(state.OUTPUT_PATH, 'client'),
        filename: '[name].js',
        chunkFilename: '[name]-[id].js',
        publicPath: '/',
        // libraryTarget: 'commonjs-module',
        libraryExport: 'default'
    }
}


// WEBPACK FOOTER //
// ./src/technologies/output.js